import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild
} from '@angular/core';
import { Omnibox } from '@local/client-contracts';
@Component({
  selector: 'suggestions-dropdown-item',
  templateUrl: './suggestions-dropdown-item.component.html',
  styleUrls: ['./suggestions-dropdown-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionsDropdownItemComponent implements AfterViewInit {
  @Input() model: Omnibox.Suggestion;
  @Input() selected: boolean;
  @ViewChild('itemTitle') itemTitle: ElementRef<any>;
  @ViewChild('titleContainer') titleContainer: ElementRef<any>;
  displayTooltip: boolean = false;

  @HostBinding('class.selected') get _selected() {
    return this.selected;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    const data = this.model.data;
    this.displayTooltip =
      this.itemTitle.nativeElement.scrollWidth > this.titleContainer.nativeElement.clientWidth ||
      (data?.value && data.value !== this.model.title);
    this.cdr.markForCheck();
  }
}
